import React from 'react';
import PrivacyPolicyPage from './PrivacyPolicyPage';

const RopefitPolicies = () => {
  return (
    <PrivacyPolicyPage
      title='RopeFit Privacy Policy'
      intro={[
        'This page informs you of our policies regarding privacy while using RopeFit.',
      ]}
      sections={[
        {
          title: 'Information We Collect',
          paragraphs: [
            <>
              RopeFit may collect workout-related data such as jump counts,
              calories burned, and workout duration. This data is stored locally
              on your device and, if you choose, synced with <b>Apple Health</b>{' '}
              or your <b>Apple Watch</b>. No personally identifiable information
              is required to use RopeFit.
            </>,
          ],
        },
        {
          title: 'Game Center',
          paragraphs: [
            <>
              If you choose to connect with <b>Game Center</b>, RopeFit may
              share your scores and achievements with Apple’s Game Center
              service. This is handled securely by Apple, and RopeFit does not
              have access to your Game Center account details.
            </>,
          ],
        },
        {
          title: 'Third-Party Services',
          paragraphs: [
            'RopeFit does not use analytics, tracking, or advertising services. The only integrations are Apple-provided services such as HealthKit and Game Center, which are governed by Apple’s privacy policies.',
          ],
        },
        {
          title: 'Children’s Privacy',
          paragraphs: [
            'RopeFit does not knowingly collect personal information from children. The App is secure and easy to use by anybody.',
          ],
        },
      ]}
      effectiveDate='2025-10-02'
      contactEmail='benjaminanoh@gmail.com'
    />
  );
};

export default RopefitPolicies;
